<template>
  <div class="sectionBox">
    <div class="alFitrBox langEn" :class="lang == 'ar' ? 'langAr':''">
      <p class="urlBtnBox" @click="urlBtn"></p>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "alFitr",
  data() {
    return {
      lang:'en'
    };
  },
  mounted() {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window['getUserInfo'] = (data) => {
          this.getUserInfo(data);
      }
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2)
      if (langs == "ar") {
        this.$i18n.locale = "ar";
        document.title = 'عيد الفطر';
        this.lang = "ar";
      } else {
        this.$i18n.locale = "en";
        this.lang = "en";
        document.title = 'Eid al-Fitr';
      }
      
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    urlBtn() {
      window.location.href = "https://q1zusf1vmau.feishu.cn/wiki/OTO7wimPIipglhkaSPDcuTftnkf"
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.sectionBox{
  height: 100vh;
  background: linear-gradient(to bottom, rgba(131, 16, 99, 1), rgba(0, 52, 78, 1), rgba(147, 11, 108, 1));
}
.alFitrBox{
  width: 640px;
  height: 1314px;
  position: relative;
}
.langEn{
  background: url('../../assets/alFitr/en.png') no-repeat;
  background-size: 100% 100%;
}
.langAr{
  background: url('../../assets/alFitr/ar.png') no-repeat;
  background-size: 100% 100%;
}
.urlBtnBox{
  width: 440px;
  height: 35px;
  position: absolute;
  bottom:  42px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
